<template>
<!-- Tabs -->
    <ul class="nav nav-tabs">
      <li class="nav-item" role="presentation">
        <button 
          class="nav-link" 
          :class="{ active: activeTab === 'form' }" 
          @click="activeTab = 'form'">
          {{ $t('Search Directly') }}
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button 
          class="nav-link" 
          :class="{ active: activeTab === 'map' }" 
          @click="activeTab = 'map'">
          {{ $t('Search By Map') }}
        </button>
      </li>
    </ul>
    <div v-if="activeTab === 'form'">
      <div class="full-search-2 eclip-search italian-search hero-search-radius shadow">
          <div class="hero-search-content">
              <div class="row">
                <div class="col-lg-2 col-md-4 col-sm-12 b-r">
                      <div class="form-group borders">
                          <div class="position-relative">
                              <input type="text" v-model="name" class="form-control border-0 ps-5" :placeholder="t('providers')">
                              <div class="position-absolute top-50 start-0 translate-middle-y ms-2">
                                  <span class="svg-icon text-primary svg-icon-2hx">
                                      <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="currentColor"/>
                                          <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="currentColor"/>
                                      </svg>
                                  </span>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="col-lg-2 col-md-3 col-sm-12">
                      <div class="form-group borders border-start">
                          <div class="position-relative ps-5">
                              <Multiselect v-model="selectedCategory" :options="categories" :no-options-text="t('noOptions')" :placeholder="t('Category')" class="form-control px-0 border-0" append-to-body open-direction="bottom" :class="{'rtl-direction': $i18n.locale === 'ar', 'ltr-direction': $i18n.locale === 'en'}" />
                              <div class="position-absolute top-50 start-0 translate-middle-y ms-2">
                                  <span class="svg-icon text-primary svg-icon-2hx">
                                      <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path opacity="0.3" d="M20 15H4C2.9 15 2 14.1 2 13V7C2 6.4 2.4 6 3 6H21C21.6 6 22 6.4 22 7V13C22 14.1 21.1 15 20 15ZM13 12H11C10.5 12 10 12.4 10 13V16C10 16.5 10.4 17 11 17H13C13.6 17 14 16.6 14 16V13C14 12.4 13.6 12 13 12Z" fill="currentColor"/>
                                          <path d="M14 6V5H10V6H8V5C8 3.9 8.9 3 10 3H14C15.1 3 16 3.9 16 5V6H14ZM20 15H14V16C14 16.6 13.5 17 13 17H11C10.5 17 10 16.6 10 16V15H4C3.6 15 3.3 14.9 3 14.7V18C3 19.1 3.9 20 5 20H19C20.1 20 21 19.1 21 18V14.7C20.7 14.9 20.4 15 20 15Z" fill="currentColor"/>
                                      </svg>
                                  </span>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="col-lg-2 col-md-3 col-sm-12">
                      <div class="form-group borders border-start">
                          <div class="position-relative ps-5">
                              <Multiselect v-model="selectedSubCategory" :options="subCategories" :no-options-text="t('noOptions')" :placeholder="t('specialization')" class="form-control px-0 border-0" append-to-body open-direction="bottom" :class="{'rtl-direction': $i18n.locale === 'ar', 'ltr-direction': $i18n.locale === 'en'}" />
                              <div class="position-absolute top-50 start-0 translate-middle-y ms-2">
                                  <span class="svg-icon text-primary svg-icon-2hx">
                                      <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path opacity="0.3" d="M20 15H4C2.9 15 2 14.1 2 13V7C2 6.4 2.4 6 3 6H21C21.6 6 22 6.4 22 7V13C22 14.1 21.1 15 20 15ZM13 12H11C10.5 12 10 12.4 10 13V16C10 16.5 10.4 17 11 17H13C13.6 17 14 16.6 14 16V13C14 12.4 13.6 12 13 12Z" fill="currentColor"/>
                                          <path d="M14 6V5H10V6H8V5C8 3.9 8.9 3 10 3H14C15.1 3 16 3.9 16 5V6H14ZM20 15H14V16C14 16.6 13.5 17 13 17H11C10.5 17 10 16.6 10 16V15H4C3.6 15 3.3 14.9 3 14.7V18C3 19.1 3.9 20 5 20H19C20.1 20 21 19.1 21 18V14.7C20.7 14.9 20.4 15 20 15Z" fill="currentColor"/>
                                      </svg>
                                  </span>
                              </div>
                          </div>
                      </div>
                  </div>
                  
                  <div class="col-lg-2 col-md-3 col-sm-12" >
                      <div class="form-group borders border-start">
                          <div class="position-relative ps-5">
                                <Multiselect v-model="selectedState" :options="states" :object="true"  :no-options-text="t('noOptions')" :placeholder="t('State')" class="form-control px-0 border-0" append-to-body open-direction="bottom" :class="{'rtl-direction': $i18n.locale === 'ar', 'ltr-direction': $i18n.locale === 'en'}"/>
                                <div class="position-absolute top-50 start-0 translate-middle-y ms-2">
                                    <img
                                      v-if="selectedState && selectedState.icon"
                                      :src="selectedState.icon"
                                      alt="State icon"
                                      style="width: 25px; height: 25px; object-fit: cover; border-radius: 50%;"
                                    />
                                    <span v-else class="svg-icon text-primary svg-icon-2hx">
                                    </span>
                                </div>
                          </div>
                      </div>
                  </div>
                  <div class="col-lg-2 col-md-3 col-sm-12" >
                      <div class="form-group borders border-start">
                          <div class="position-relative ps-5">
                              <Multiselect v-model="selectedCity" :options="cities" :no-options-text="t('noOptions')" :placeholder="t('Area')" class="form-control px-0 border-0" append-to-body open-direction="bottom" :class="{'rtl-direction': $i18n.locale === 'ar', 'ltr-direction': $i18n.locale === 'en'}" />
                              <div class="position-absolute top-50 start-0 translate-middle-y ms-2">
                                  <span class="svg-icon text-primary svg-icon-2hx">
                                      <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path opacity="0.3" d="M18.0624 15.3453L13.1624 20.7453C12.5624 21.4453 11.5624 21.4453 10.9624 20.7453L6.06242 15.3453C4.56242 13.6453 3.76242 11.4453 4.06242 8.94534C4.56242 5.34534 7.46242 2.44534 11.0624 2.04534C15.8624 1.54534 19.9624 5.24534 19.9624 9.94534C20.0624 12.0453 19.2624 13.9453 18.0624 15.3453Z" fill="currentColor"/>
                                          <path d="M12.0624 13.0453C13.7193 13.0453 15.0624 11.7022 15.0624 10.0453C15.0624 8.38849 13.7193 7.04535 12.0624 7.04535C10.4056 7.04535 9.06241 8.38849 9.06241 10.0453C9.06241 11.7022 10.4056 13.0453 12.0624 13.0453Z" fill="currentColor"/>
                                      </svg>
                                  </span>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="col-lg-2 col-md-2 col-sm-12">
                      <div class="form-group">
                          <button type="button" @click="searchProvider" class="btn btn-primary fw-medium full-width">{{ t('Search') }}</button>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </div>
    <div v-show="activeTab === 'map'">
      <div class="full-search-2 eclip-search italian-search hero-search-radius shadow">
          <div class="hero-search-content">
              <div class="row">
                <div class="col-lg-2 col-md-4 col-sm-12 b-r">
                      <div class="form-group borders">
                          <div class="position-relative">
                              <input type="text" v-model="name" class="form-control border-0 ps-5" :placeholder="t('providers')">
                              <div class="position-absolute top-50 start-0 translate-middle-y ms-2">
                                  <span class="svg-icon text-primary svg-icon-2hx">
                                      <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="currentColor"/>
                                          <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="currentColor"/>
                                      </svg>
                                  </span>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="col-lg-2 col-md-3 col-sm-12">
                      <div class="form-group borders border-start">
                          <div class="position-relative ps-5">
                              <Multiselect v-model="selectedCategory" :options="categories" :no-options-text="t('noOptions')" :placeholder="t('Category')" class="form-control px-0 border-0" append-to-body open-direction="bottom" :class="{'rtl-direction': $i18n.locale === 'ar', 'ltr-direction': $i18n.locale === 'en'}" />
                              <div class="position-absolute top-50 start-0 translate-middle-y ms-2">
                                  <span class="svg-icon text-primary svg-icon-2hx">
                                      <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path opacity="0.3" d="M20 15H4C2.9 15 2 14.1 2 13V7C2 6.4 2.4 6 3 6H21C21.6 6 22 6.4 22 7V13C22 14.1 21.1 15 20 15ZM13 12H11C10.5 12 10 12.4 10 13V16C10 16.5 10.4 17 11 17H13C13.6 17 14 16.6 14 16V13C14 12.4 13.6 12 13 12Z" fill="currentColor"/>
                                          <path d="M14 6V5H10V6H8V5C8 3.9 8.9 3 10 3H14C15.1 3 16 3.9 16 5V6H14ZM20 15H14V16C14 16.6 13.5 17 13 17H11C10.5 17 10 16.6 10 16V15H4C3.6 15 3.3 14.9 3 14.7V18C3 19.1 3.9 20 5 20H19C20.1 20 21 19.1 21 18V14.7C20.7 14.9 20.4 15 20 15Z" fill="currentColor"/>
                                      </svg>
                                  </span>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="col-lg-2 col-md-3 col-sm-12">
                      <div class="form-group borders border-start">
                          <div class="position-relative ps-5">
                              <Multiselect v-model="selectedSubCategory" :options="subCategories" :no-options-text="t('noOptions')" :placeholder="t('specialization')" class="form-control px-0 border-0" append-to-body open-direction="bottom" :class="{'rtl-direction': $i18n.locale === 'ar', 'ltr-direction': $i18n.locale === 'en'}" />
                              <div class="position-absolute top-50 start-0 translate-middle-y ms-2">
                                  <span class="svg-icon text-primary svg-icon-2hx">
                                      <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path opacity="0.3" d="M20 15H4C2.9 15 2 14.1 2 13V7C2 6.4 2.4 6 3 6H21C21.6 6 22 6.4 22 7V13C22 14.1 21.1 15 20 15ZM13 12H11C10.5 12 10 12.4 10 13V16C10 16.5 10.4 17 11 17H13C13.6 17 14 16.6 14 16V13C14 12.4 13.6 12 13 12Z" fill="currentColor"/>
                                          <path d="M14 6V5H10V6H8V5C8 3.9 8.9 3 10 3H14C15.1 3 16 3.9 16 5V6H14ZM20 15H14V16C14 16.6 13.5 17 13 17H11C10.5 17 10 16.6 10 16V15H4C3.6 15 3.3 14.9 3 14.7V18C3 19.1 3.9 20 5 20H19C20.1 20 21 19.1 21 18V14.7C20.7 14.9 20.4 15 20 15Z" fill="currentColor"/>
                                      </svg>
                                  </span>
                              </div>
                          </div>
                      </div>
                  </div>
                  
                  <div class="col-lg-2 col-md-3 col-sm-12" >
                      <div class="form-group borders border-start">
                          <div class="position-relative ps-5">
                                <Multiselect v-model="selectedState" :options="states" :object="true"  :no-options-text="t('noOptions')" :placeholder="t('State')" class="form-control px-0 border-0" append-to-body open-direction="bottom" :class="{'rtl-direction': $i18n.locale === 'ar', 'ltr-direction': $i18n.locale === 'en'}"/>
                                <div class="position-absolute top-50 start-0 translate-middle-y ms-2">
                                    <img
                                      v-if="selectedState && selectedState.icon"
                                      :src="selectedState.icon"
                                      alt="State icon"
                                      style="width: 25px; height: 25px; object-fit: cover; border-radius: 50%;"
                                    />
                                    <span v-else class="svg-icon text-primary svg-icon-2hx">
                                    </span>
                                </div>
                          </div>
                      </div>
                  </div>
                  <div class="col-lg-2 col-md-3 col-sm-12" >
                      <div class="form-group borders border-start">
                          <div class="position-relative ps-5">
                              <Multiselect v-model="selectedCity" :options="cities" :no-options-text="t('noOptions')" :placeholder="t('Area')" class="form-control px-0 border-0" append-to-body open-direction="bottom" :class="{'rtl-direction': $i18n.locale === 'ar', 'ltr-direction': $i18n.locale === 'en'}" />
                              <div class="position-absolute top-50 start-0 translate-middle-y ms-2">
                                  <span class="svg-icon text-primary svg-icon-2hx">
                                      <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path opacity="0.3" d="M18.0624 15.3453L13.1624 20.7453C12.5624 21.4453 11.5624 21.4453 10.9624 20.7453L6.06242 15.3453C4.56242 13.6453 3.76242 11.4453 4.06242 8.94534C4.56242 5.34534 7.46242 2.44534 11.0624 2.04534C15.8624 1.54534 19.9624 5.24534 19.9624 9.94534C20.0624 12.0453 19.2624 13.9453 18.0624 15.3453Z" fill="currentColor"/>
                                          <path d="M12.0624 13.0453C13.7193 13.0453 15.0624 11.7022 15.0624 10.0453C15.0624 8.38849 13.7193 7.04535 12.0624 7.04535C10.4056 7.04535 9.06241 8.38849 9.06241 10.0453C9.06241 11.7022 10.4056 13.0453 12.0624 13.0453Z" fill="currentColor"/>
                                      </svg>
                                  </span>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="col-lg-2 col-md-2 col-sm-12">
                      <div class="form-group">
                          <button type="button" @click="searchOnMap" class="btn btn-primary fw-medium full-width">{{ t('Search') }}</button>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <br>
      <div ref="mapContainer" style="width: 100%; height: 420px;"></div>
    </div>
</template>

<script setup>
/*global google*/
import Multiselect from '@vueform/multiselect';
import '@vueform/multiselect/themes/default.css';
import { ref, watch, onMounted, nextTick } from "vue";
import axios from "axios";
import { useRouter } from "vue-router";
import {useI18n} from "vue-i18n";
import { useToast } from "vue-toastification"
import { MarkerClusterer } from "@googlemaps/markerclusterer";

const router = useRouter();
const toast = useToast()
const  {t} = useI18n();
const { locale } = useI18n();
const states = ref([]);
const categories = ref([]);
const cities = ref([]);
const subCategories = ref([]);
const selectedCategory = ref(null);
const selectedSubCategory = ref(null);
const selectedState = ref(null);
const selectedCity = ref(null);
const name = ref("");
const loading = ref(false);
let markerCluster = null;

const fetchStates = async () => {
  loading.value = true;
  try {
    const response = await axios.get(`/get-states`, {
        headers: {
            'locale': locale.value
        }
    });
    const fetchedStates = response.data.states || [];
    states.value = fetchedStates.map(state => ({
      label: state.name,
      value: state.id,
      icon: state.icon
    }));
  } catch (error) {
    console.error("Error fetching states:", error);
  } finally {
    loading.value = false;
  }
};
console.log("selectedState",selectedState.value);

const fetchCities = async () => {
  if (!selectedState.value) return;

  try {
    const response = await axios.get(`/get-cities/${selectedState.value.value}`, {
        headers: {
            'locale': locale.value
        }
    });
       const fetchedCities = response.data.cities || [];
      cities.value = fetchedCities.map(city => ({
        label: city.name,
        value: city.id,
      }));
  } catch (error) {
    console.error("Error fetching cities:", error);
  }
};
watch(selectedState, () => {
  selectedCity.value = null;
  fetchCities();
});
const fetchCategories = async () => {
  loading.value = true;
  try {
    const response = await axios.get(`/get-categories`, {
        headers: {
            'locale': locale.value
        }
    });
    const fetchedCategories = response.data.categories || [];
    categories.value = fetchedCategories.map(category => ({
      label:category.name,
      value: category.id
    }));
  } catch (error) {
    console.error("Error fetching categories:", error);
  } finally {
    loading.value = false;
  }
};
const fetchSubCategories = async () => {
  loading.value = true;
  try {
    const response = await axios.get(`/get-subcategories`,{
      params: { category_id: selectedCategory.value},
      headers: {
        'locale': locale.value
        }
    });
    const fetchedSubCategories = response.data.subcategory || [];
    subCategories.value = fetchedSubCategories.map(subCategory => ({
      label: subCategory.name,
      value: subCategory.id
    }));
  } catch (error) {
    console.error("Error fetching sub categories:", error);
  } finally {
    loading.value = false;
  }
};
watch(selectedCategory, () => {
  selectedSubCategory.value = null;
  fetchSubCategories();
});

watch(locale, fetchStates, { immediate: true });
watch(locale, fetchCategories, { immediate: true });
const searchProvider = () => {
    router.push({
        path: "/provider/search",
        query: {
            category_id: selectedCategory?.value || '',
            state_id: selectedState?.value?.value || '',
            city_id: selectedCity?.value || '',
            subcategory_id: selectedSubCategory?.value || '',
            name: name.value || null,
        }
    });
};
watch(locale, (newLocale) => {
  const direction = newLocale === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.setAttribute('dir', direction);
}, { immediate: true });


// MAP FUNCTIONS
const activeTab = ref("form");
const mapContainer = ref(null);
let map = null;
let markersMap = new Map(); 
let fetchTimeout = null;
const infoWindow = new google.maps.InfoWindow(); 

function updateMarkers(providers) {
  const newIds = new Set(providers.map(p => p.id));

  for (let [id, marker] of markersMap.entries()) {
    if (!newIds.has(id)) {
      markerCluster.removeMarker(marker); 
      marker.setMap(null);
      markersMap.delete(id);
    }
  }

  providers.forEach(provider => {
    if (!provider.latitude || !provider.longitude) return;

    if (!markersMap.has(provider.id)) {
      const offset = (Math.random() - 0.5) * 0.0001;
      const marker = new google.maps.Marker({
        position: {
          lat: parseFloat(provider.latitude) + offset,
          lng: parseFloat(provider.longitude) + offset,
        },
        map,
        title: provider.name,
      });

      const categoryName = provider.category?.name || '';

      marker.addListener("click", () => {
        infoWindow.setContent(`
          <div class="map-info-window">
            <div class="map-row">
              <div class="map-col">
                <a href="/service-provider/show-details/${provider.id}" target="_blank">
                  <div class="map-image-wrapper">
                    <img src="${provider.profile_image}" class="map-img" alt="${provider.name}" />
                  </div>
                </a>
              </div>
              <div class="map-col">
                <a href="/service-provider/show-details/${provider.id}" target="_blank">
                  <h5 class="map-title">${provider.name}</h5>
                </a>
                <p class="map-category">${categoryName}</p>
              </div>
            </div>
          </div>
        `);
        infoWindow.open(map, marker);
      });

      markersMap.set(provider.id, marker);
      markerCluster.addMarker(marker);
    }
  });
}

const fetchProvidersByLocation = async (lat, lng) => {
  try {
    const formData = new FormData();
    formData.append('currentLat', lat);
    formData.append('currentLng', lng);

    const response = await axios.post('/get-provider-by-location', formData, {
      headers: { 'Content-Type': 'multipart/form-data', 'locale': locale.value },
    });

    const providers = response.data.service_provider || [];
    updateMarkers(providers);
  } catch (error) {
    console.error("Error fetching providers by location:", error);
  }
};

const fetchProvidersWithinBounds = async () => {
  try {
    if (!map) return;
    const bounds = map.getBounds();
    if (!bounds) return;

    const params = {
      lat1: bounds.getSouthWest().lat(),
      lng1: bounds.getSouthWest().lng(),
      lat2: bounds.getNorthEast().lat(),
      lng2: bounds.getNorthEast().lng(),
    };

    const response = await axios.get('/users/list-service-provider-without-paginate', {
      params,
      headers: { 'locale': locale.value }
    });

    const providers = response.data.service_providers || [];
    updateMarkers(providers);

  } catch (error) {
    console.error("Error fetching providers within bounds:", error);
  }
};

const initMap = async () => {
  await nextTick();
  if (!map && mapContainer.value) {
    map = new google.maps.Map(mapContainer.value, {
      center: { lat: 33.5138, lng: 36.2765 },
      zoom: 10,
    });
    markerCluster = new MarkerClusterer({ map, markers: [] });
    map.addListener("click", async (e) => {
      const lat = e.latLng.lat();
      const lng = e.latLng.lng();
      await fetchProvidersByLocation(lat, lng);
    });

    map.addListener("idle", () => {
      if (fetchTimeout) clearTimeout(fetchTimeout);
      fetchTimeout = setTimeout(() => {
        fetchProvidersWithinBounds();
      }, 400); 
    });
  }
};

const searchOnMap = async () => {
  try {
    const params = {
      category_id: selectedCategory?.value || '',
      state_id: selectedState?.value?.value || '',
      city_id: selectedCity?.value || '',
      subcategory_id: selectedSubCategory?.value || '',
      name: name.value || null,
    };

    const response = await axios.get('/users/list-service-provider-without-paginate', { 
      params,
      headers: { 'locale': locale.value }
    });

    const providers = response.data.service_providers || [];
      markersMap.forEach(marker => {
      markerCluster.removeMarker(marker);
      marker.setMap(null);
    });

    markersMap.clear();
    
    if (providers.length > 0) {
      updateMarkers(providers);

      const bounds = new google.maps.LatLngBounds();
      providers.forEach(p => {
        if (p.latitude && p.longitude) {
          bounds.extend({ lat: parseFloat(p.latitude), lng: parseFloat(p.longitude) });
        }
      });
      map.fitBounds(bounds);

    } else {
      toast.error(t('No providers found for the selected search criteria'));
    }

  } catch (error) {
    console.error("Error searching providers:", error);
    alert('Failed to fetch providers. Please try again.');
  }
};

watch(activeTab, (newTab) => {
  if (newTab === 'map') {
    initMap();
    fetchProvidersWithinBounds();
  }
});

onMounted(() => {
  initMap();
});

</script>
<style scoped>
@media (max-width: 768px) {
  .multiselect {
    width: 100%;
    font-size: 16px;
  }
}
.map-container {
  width: 100%;
  height: 300px;
}

.rtl-direction {
  direction: rtl;
}

.ltr-direction {
  direction: ltr;
}
</style>

<style>
@media (max-width: 768px) {
  .multiselect {
    width: 100%;
    font-size: 16px;
  }
}
.multiselect-option.is-selected {
  background-color: #6A715D;
  color: white;
}
.multiselect-option {
    align-items: center;
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    font-size: var(--ms-option-font-size, 1rem);
    justify-content: flex-start;
    line-height: var(--ms-option-line-height, 1.375);
    padding: var(--ms-option-py, .5rem) var(--ms-option-px, .75rem);
    text-align: left;
    text-decoration: none;
}

html[dir="rtl"] .multiselect-option {
  direction: rtl;
  text-align: right;
}

html[dir="ltr"] .multiselect-option {
  direction: ltr;
  text-align: left;
}
.multiselect-option.is-selected.is-pointed {
    background: var(--ms-option-bg-selected-pointed, #578F33 );
    color: var(--ms-option-color-selected-pointed, #fff);
}
.nav-link:focus, .nav-link:hover {
    color: #578F33 !important;
}
.nav-link {
    display: block;
    padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
    font-size: var(--bs-nav-link-font-size);
    font-weight: var(--bs-nav-link-font-weight);
    color: #578F33 !important;
    text-decoration: none;
    background: 0 0;
    border: 0;
    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out;
}

.map-info-window {
  width: 300px;
  font-family: Arial, sans-serif;
}

.map-row {
  display: flex;
  gap: 10px;
}

.map-col {
  flex: 1;
  text-align: center;
}

.map-image-wrapper {
  overflow: hidden;
  border-radius: 8px;
  height: 80px; 
}

.map-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.map-col .map-title {
  font-size: 12px;
  margin: 10px 0 5px 0;
  color: #578F33;
}

.map-col .map-category {
  font-size: 10px;
  color: #578F33;
  margin: 0;
}

</style>